<template>
  <v-card class="rounded-0" color="darken-2" dark flat>
    <v-dialog v-model="openMap" activator="parent" class="p-10" width="900">
      <v-card class="p-10">
        <location-show v-if="openMap" v-model="mapsData"></location-show>
      </v-card>
    </v-dialog>

    <v-card-title class="font-size-h3 font-weight-bold pt-6">
      {{ value.organizationName }}
    </v-card-title>
    <v-card-subtitle v-text="value.subOrgan" />

    <v-card-text class="font-size-h6">
      {{ value.userName || "" }}
      <template v-if="value.workField">
        <span class="mx-2">سمت : </span>
        {{ value.workField || "" }}
      </template>
    </v-card-text>

    <v-card-text v-if="value.website" class="font-size-h5 d-flex flex-column">
      <a
        :style="{ color: value.textCards.sectionColor.text }"
        class="mt-2"
        @click="goToUrl(value.website)"
      >
        <v-icon
          :style="{ color: value.textCards.sectionColor.text }"
          class="ml-auto"
          >mdi-web</v-icon
        >
        {{ value.website }}
      </a>
    </v-card-text>

    <v-card-text class="py-0">
      <a
        v-if="value.location"
        :style="{ color: value.textCards.sectionColor.text }"
        @click="bringMap"
      >
        <v-icon
          :style="{ color: value.textCards.sectionColor.text }"
          class="ml-auto"
          >mdi-map-marker</v-icon
        >
        {{ value.location }}
      </a>
    </v-card-text>

    <v-row class="py-4 mt-0" no-gutters>
      <v-col class="d-flex flex-column" cols="6">
        <v-card-title v-text="'تماس با ما'" />

        <a
          v-for="item in value.phoneNumber"
          v-if="value.phoneNumber && value.phoneNumber[0].number"
          :key="item.number"
          :href="`tel:${item.number}`"
          :style="{ color: value.textCards.sectionColor.text }"
        >
          <v-icon
            :style="{ color: value.textCards.sectionColor.text }"
            class="ml-2"
            >mdi-phone</v-icon
          >
          {{ item.number }}
          <span>{{ item.text }}</span>
        </a>

        <!--        <a v-if="value.companyNumber" :href="`tel:${value.companyNumber}`" class="mt-2"-->
        <!--           :style="{color:value.textCards.sectionColor.text} ">-->
        <!--          <v-icon class="ml-2" :style="{color:value.textCards.sectionColor.text} ">mdi-phone</v-icon>-->
        <!--          {{ value.companyNumber }}-->
        <!--        </a>-->

        <a
          v-if="value.fax"
          :href="`tel:${value.fax}`"
          :style="{ color: value.textCards.sectionColor.text }"
          class="mt-2"
        >
          <v-icon
            :style="{ color: value.textCards.sectionColor.text }"
            class="ml-2"
            >mdi-fax</v-icon
          >
          {{ value.fax }}
        </a>

        <a
          v-if="value.codePostal"
          :style="{ color: value.textCards.sectionColor.text }"
          class="mt-2"
        >
          <v-icon
            :style="{ color: value.textCards.sectionColor.text }"
            class="ml-2"
            >mdi-post</v-icon
          >
          {{ value.codePostal }}
        </a>

        <template v-if="hasExtra">
          <v-row
            v-for="(item, i) in value.extraFields"
            :key="i"
            :style="{ color: value.textCards.sectionColor.text }"
            class="pt-2"
            no-gutters
          >
            <v-col
              :class="{ 'link-tag': extraIsLink(item) }"
              :href="extraIsLink(item) ? fixLink(item.link) : false"
              :style="{ color: value.textCards.sectionColor.text }"
              :tag="extraIsLink(item) ? 'a' : 'div'"
              class="d-flex align-start"
              cols="12"
              target="_blank"
            >
              <span v-if="item.icon" class="text-no-wrap me-1">
                <v-icon :style="{ color: value.textCards.sectionColor.text }">{{
                  item.icon
                }}</v-icon>
                :
              </span>
              <pre
                v-if="item.value"
                :key="i"
                :class="extraIsLink(item) ? 'link-tag' : ''"
                :style="{ color: value.textCards.sectionColor.text }"
                class="text-right mb-0"
                v-html="item.value"
              />
            </v-col>
            <v-col class="py-2" cols="12">
              <v-divider
                v-show="i + 1 < value.extraFields.length"
                class="my-0"
              />
            </v-col>
          </v-row>
        </template>

        <a
          v-if="value.email"
          :href="`mailto:${value.email}`"
          :style="{ color: value.textCards.sectionColor.text }"
          class="my-2 d-flex"
        >
          <v-icon
            :style="{ color: value.textCards.sectionColor.text }"
            class="ml-2"
            >mdi-email</v-icon
          >
          {{ value.email }}
        </a>
      </v-col>

      <v-card-text>
        <div class="row d-flex">
          <div
            v-for="(item, index) in countSocial"
            :key="index"
            class="d-flex"
            style="flex-wrap: wrap"
          >
            <v-btn
              class="m-2"
              dark
              icon
              small
              @click="goToUrl(item.url, item.pattern)"
            >
              <img :alt="item.label" :src="item.img" />
            </v-btn>
          </div>
        </div>
      </v-card-text>

      <v-card-text v-if="!!value.WorkSheet">
        <template v-for="(item, i) in value.WorkSheet.items">
          <div
            v-if="
              Object.values(item.shift[0]).length > 0 ||
              Object.values(item.shift[1]).length > 0
            "
            :key="i"
            class="row mt-2"
          >
            <h6>{{ item.name }}</h6>
            <template v-for="(time, index) in item.shift">
              <div
                v-if="!!Object.keys(time).length"
                :key="index"
                class="col-12 d-flex mx-auto my-0 pb-0"
              >
                <p
                  v-if="
                    item.shift.filter((t) => !!Object.keys(t).length).length > 1
                  "
                  class="font-weight-bold"
                >
                  {{ index === 0 ? "شیفت اول" : "شیفت دوم" }}
                </p>
                <p v-if="time.start" class="mx-auto">
                  <span class="d-inline-block">ساعت شروع :</span>
                  {{ time.start }}
                </p>
                <p v-if="time.end" class="mx-auto">
                  <span class="d-inline-block">ساعت پایان :</span>
                  {{ time.end }}
                </p>
              </div>
            </template>

            <v-divider />
          </div>
        </template>
      </v-card-text>

      <v-col class="d-flex flex-column" cols="12">
        <v-card-title v-text="'درباره ما'" />
        <div
          class="col-md-11 mt-0 pt-0"
          style="white-space: pre-line"
          v-html="value.aboutUs"
        ></div>
      </v-col>

      <v-col cols="12">
        <v-divider />
      </v-col>

      <v-col class="px-4" cols="12">
        <p class="text-center" v-html="value.copyright" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import LocationShow from "@/view/pages/businessPage/components/view/locationShow";

export default {
  name: "bFooterView",

  components: { LocationShow },

  props: {
    value: Object,
  },

  data: () => ({
    items: [
      {
        title: "درباره ما",
        links: ["امکانات", "همکاران", "برنامه های وابسته", "پنل ها"],
      },
      {
        title: "تماس با ما",
        links: ["تیکت پشتیبانی", "خدمات حضوری", "ارتباط زنده", "سوالات متداول"],
      },
    ],
    openMap: false,
    mapsData: [],
  }),

  computed: {
    countSocial() {
      var value = [];
      Object.keys(this.value.socialMedia).forEach((x) => {
        value.push(...this.value.socialMedia[x]);
      });
      return value;
    },
    hasExtra() {
      let arr = this.value.extraFields?.filter(
        (item) => !!item.name || !!item.icon || !!item.value
      );
      return arr && arr.length > 0;
    },
  },

  methods: {
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
    extraIsLink(item) {
      return item.link && item.link.length > 0;
    },
    fixLink(link) {
      return link.startsWith("http") ? link : "https://" + link;
    },
    bringMap() {
      this.openMap = true;
      this.mapsData = this.value.coordinates;
    },
  },
};
</script>

<style scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
  color: inherit !important;
}

a {
  color: rgba(255, 255, 255, 0.7);
}
</style>
